import React, { useState, useEffect, useContext } from "react";
import Instance from "../../Services/Instance";
import config from "../../Services/config.js";
import SideBar from "../../Layouts/SideBar";
import { DataContext } from "../../Services/DataContext";
import { useParams } from "react-router-dom";
import "../../Assets/Styles/Products.css"; 
import "../../Assets/Styles/Blog.css"; 

function EditFaq() {
    const { posts } = useContext(DataContext);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);
    const [faq, setFaq] = useState({
        category: "",
        title: "",
        answer: "",
        keywords: "",
        isPublished: true
    });
    
    const { id } = useParams();

    const onInputChange = (e) => {
        setFaq({ ...faq, [e.target.name]: e.target.value });
    };

    const onCheckboxChange = (e) => {
        setFaq({ ...faq, [e.target.name]: e.target.checked });
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const result = await Instance.get(`${config.api_url}/faq/items/${id}`);
                const faqData = result.data.data;
                setFaq({
                    category: faqData.category._id,
                    title: faqData.title,
                    answer: faqData.answer,
                    keywords: faqData.keywords?.join(', ') || '',
                    isPublished: faqData.isPublished
                });
                setLoading(false);
            } catch (error) {
                setError(error);
                //console.log(error);
                setLoading(false);
            }
        };

        fetchData();
    }, [id]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const keywordsArray = faq.keywords 
                ? faq.keywords.split(',').map(k => k.trim()).filter(k => k)
                : [];

            await Instance.patch(`${config.api_url}/faq/items/${id}`, {
                category: faq.category,
                title: faq.title,
                answer: faq.answer,
                keywords: keywordsArray,
                isPublished: faq.isPublished
            });
            window.location = "/dashboard/faq/new-faq";
        } catch (error) {
            console.error("Erreur lors de la modification:", error);
            setError(error);
        }
    };

    if (loading) {
        return (
            <div className='a-new-post'>
                <SideBar />
                <div className="parent-new-product">
                    <p>Chargement...</p>
                </div>
            </div>
        );
    }

    return (
        <div className='a-new-post'>
            <SideBar />
            <div className="parent-new-product">
                <form onSubmit={(e) => handleSubmit(e)} className="new-product custom-layout-product">
                    <div className="form-display">
                        <div>
                            <label htmlFor="category">Catégorie</label>
                            <select
                                className="input"
                                value={faq.category}
                                name="category"
                                onChange={(e) => onInputChange(e)}
                                required={true}
                            >
                                <option value="">Sélectionnez une catégorie</option>
                                {posts && posts.map((cat) => (
                                    <option key={cat._id} value={cat._id}>
                                        {cat.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div>
                            <label htmlFor="title">Question</label>
                            <input
                                className="input"
                                value={faq.title}
                                name="title"
                                type="text"
                                onChange={(e) => onInputChange(e)}
                                required={true}
                            />
                        </div>

                        <div id="description">
                            <label htmlFor="answer">Réponse</label>
                            <textarea
                                className="input"
                                value={faq.answer}
                                name="answer"
                                onChange={(e) => onInputChange(e)}
                                required={true}
                            />
                        </div>

                        <div>
                            <label htmlFor="keywords">Mots-clés (séparés par des virgules)</label>
                            <input
                                className="input"
                                value={faq.keywords}
                                name="keywords"
                                type="text"
                                onChange={(e) => onInputChange(e)}
                            />
                        </div>

                        <div>
                            <label htmlFor="isPublished">
                                <input
                                    type="checkbox"
                                    name="isPublished"
                                    checked={faq.isPublished}
                                    onChange={(e) => onCheckboxChange(e)}
                                />
                                {" "}Publier la FAQ
                            </label>
                        </div>
                    </div>

                    <div className="validate">
                        <button type="submit" className="add-new-element">
                            Modifier
                        </button>
                    </div>
                </form>
            </div>
            {error && (
                <h1 style={{ color: "red", position: "fixed", left: "10%", bottom: "10%" }}>
                    {error.response?.data?.message || "Une erreur est survenue"}
                </h1>
            )}
        </div>
    );
}

export default EditFaq;